export const countDays = (
  startingDate: Date,
  endingDate: Date,
  dayToCount: number
) => {
  let countedDays = 0
  let currentDate = new Date(startingDate)

  while (currentDate <= endingDate) {
    const day = currentDate.getDay()
    if (day === dayToCount) {
      countedDays++
    }
    currentDate = new Date(+currentDate + 1000 * 60 * 60 * 24)
  }

  return countedDays
}
